import { SplitsAvatar } from '~/components/SplitsAvatar'
import { AddressDisplay } from '~/components/component-library'
import { AddressPopover } from '~/components/component-library/AddressDisplay/AddressPopover'
import { useContactLookup } from '~/hooks/useContacts'
import { IAddress } from '~/types'
import { EvmAddress } from '~/utils/address'

export const RecoverySignerDisplay = ({
  address,
  name,
  email,
}: {
  address: string
  name?: string
  email?: string
}) => {
  const formattedAddress = EvmAddress.format(address)
  // Prefer the contact label so the row stays in sync with the popover
  // and with renames made from the edit dialog.
  const { data: contact } = useContactLookup(formattedAddress as IAddress)
  const displayName = contact?.orgLabel ?? name

  if (email) {
    return (
      <AddressPopover address={formattedAddress}>
        <div className="flex w-full min-w-0 items-center gap-2 text-base text-primary">
          <SplitsAvatar address={formattedAddress} size={24} />
          {/* The email is how this signer logs in, so the name gives way
              first, down to 30% of the row; the address stays in the popover.
              Don't cap the email with a percentage max-width: the popover
              trigger sizes to its content, so it would clip with room left. */}
          <span className="max-w-max shrink-0 grow basis-[30%] truncate">
            {displayName ?? email}
          </span>
          {displayName && (
            <span className="min-w-0 truncate text-sm text-secondary">
              {email}
            </span>
          )}
        </div>
      </AddressPopover>
    )
  }

  return <AddressDisplay address={formattedAddress} layout="standard" />
}
